import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EChartTypes = {
	line: 'LINE_CHART',
	bar: 'BAR_CHART',
} as const;

export const ESeverity = {
	warning: 'WARNING',
	critical: 'CRITICAL',
	error: 'ERROR',
	informational: 'INFORMATIONAL',
} as const;

export const ESeverityLabels = {
	warning: 'Warning',
	critical: 'Critical',
	error: 'Error',
	informational: 'Informational',
} as const;

export const EKpiAlertsStatus = {
	inactive: 'INACTIVE',
	active: 'ACTIVE',
} as const;

export const EKpiNotificationsStatusLabels = {
	inactive: 'Inactive',
	active: 'Active',
} as const;

export const EGranularitiesValues = {
	daily: 'DAILY',
	hourly: 'HOURLY',
	monthly: 'MONTHLY',
	every_minute: 'EVERY_MINUTE',
	every_15_minute: 'EVERY_15_MINUTE',
} as const;

export const EGranularitiesLabels: Record<keyof typeof EGranularitiesValues, string> = {
	daily: 'Daily',
	hourly: 'Hourly',
	monthly: 'Monthly',
	every_minute: 'Every Minute',
	every_15_minute: 'Every 15 minutes',
} as const;

export const EPresetsGroupNames = {
	shared: 'Shared',
	personal: 'Personal',
} as const;

export type EGranularityValue = (typeof EGranularitiesValues)[keyof typeof EGranularitiesValues];
export type TChartTypes = TValueOfStringRecord<typeof EChartTypes>
export type TSeverity = TValueOfStringRecord<typeof ESeverity>
export type TSeverityLabels = TValueOfStringRecord<typeof ESeverityLabels>
export type TKpiAlertsStatus = TValueOfStringRecord<typeof EKpiAlertsStatus>
export type TKpiNotificationsStatusLabels = TValueOfStringRecord<typeof EKpiNotificationsStatusLabels>
